import React from 'react'
import { AlertContentType } from './index'
import Text from 'particles/Text'
import { StyledBannerAlert } from './style'
import IconButton from 'particles/Button/IconButton'

interface BannerAlertProps {
    contentType: AlertContentType
    title?: string
    subText: any // todo: temp assign any to support NewTrans any type. can refactor this after remove all NewTrans
    showClose?: boolean
    onClickClose?: () => void
}

const BannerAlert: React.FC<BannerAlertProps> = ({ contentType, title, subText, showClose, onClickClose }) => {
    return (
        <StyledBannerAlert contentType={contentType}>
            <div className="text-container">
                {title && (
                    <Text className="title" scale={'bodyM700'} color={'primary'}>
                        {title}
                    </Text>
                )}
                {subText && (
                    <Text scale={'bodyM400'} color={'primary'}>
                        {subText}
                    </Text>
                )}
            </div>
            {showClose ? (
                <IconButton
                    form="icon"
                    size="s"
                    color="neutral"
                    icon="x"
                    onClick={onClickClose}
                    className="close-button"
                />
            ) : null}
        </StyledBannerAlert>
    )
}

export default BannerAlert
